import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect, useState } from "react";
import MuiAvatar from "@mui/material/Avatar";
import AccountCircle from "@mui/icons-material/AccountCircle";
import classNames from "classnames";
import useStyles from "./styles";
import md5 from "md5";
import { CacheProvider } from "../Utilities/cache/cacheProvider";
import Typography from "../Typography";
import Tooltip from "../Tooltip";
import Link from "../Link";
import { createInitials } from "../Utilities/StringHelper";

/**
 * @deprecated Use AvatarProps instead
 */

export const Avatar = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    alt,
    className,
    children,
    gutter = "none",
    src,
    size = "small",
    name,
    displayName,
    LinkProps,
    email,
    DisplayNameProps,
    ...otherProps
  } = props;
  const classes = useStyles(props);
  const [state, setState] = useState(undefined);
  const hasChildren = !children && !name ? false : true;
  const renderedAlt = alt ? alt : name;
  const ConditionalWrapper = ({
    condition,
    wrapper,
    children
  }) => condition ? wrapper(children) : /*#__PURE__*/React.createElement(React.Fragment, null, children);
  const getGravatar = async email => {
    const request = new XMLHttpRequest();
    const emailMd5 = md5(email?.trim().toLowerCase());
    const cache = CacheProvider.getInstance();
    const cacheKey = `gravatar:${email}`;
    const cachedImage = cache.get(cacheKey);
    if (cachedImage !== undefined) {
      setState(cachedImage);
      return;
    }
    request.onload = () => {
      if (request.status === 200) {
        cache.set(cacheKey, `https://www.gravatar.com/avatar/${emailMd5}.png?d=404`);
        setState(`https://www.gravatar.com/avatar/${emailMd5}.png?d=404`);
      } else {
        cache.set(cacheKey, undefined);
        setState(undefined);
      }
    };
    request.open("GET", `https://www.gravatar.com/avatar/${emailMd5}.png?d=404`);
    request.send();
  };
  const checkGutter = () => {
    if (displayName === "right" && gutter === "none") return "";
    return "gutter" + gutter;
  };
  const renderedChildren = children ? children : name ? createInitials(name) : /*#__PURE__*/React.createElement(AccountCircle, {
    className: classNames("prmbl-avatar-default", classes["gutter" + gutter], classes["default" + size])
  });
  //This is for changing/updating the gravatar when the email is changed.
  useEffect(() => {
    if (email && src === undefined) {
      const emailMd5 = md5(email.trim().toLowerCase());
      if (!state?.includes(emailMd5)) {
        setState(undefined);
        getGravatar(email);
      }
    }
  }, [email, src, state]);
  return /*#__PURE__*/React.createElement(ConditionalWrapper, {
    condition: LinkProps,
    wrapper: children => {
      return /*#__PURE__*/React.createElement(Link, _extends({
        className: classNames({
          [classes.hoverLink]: LinkProps?.underline !== "none",
          [classes.alwaysLink]: LinkProps?.underline === "always"
        }, classes.withNameWrapper, {
          ...LinkProps?.classes
        })
      }, LinkProps, {
        underline: "none"
      }), children);
    }
  }, /*#__PURE__*/React.createElement(ConditionalWrapper, {
    condition: displayName,
    wrapper: children => {
      if (displayName === "tooltip") return /*#__PURE__*/React.createElement(Tooltip, _extends({
        title: name
      }, DisplayNameProps), children);else if (displayName === "right") return /*#__PURE__*/React.createElement("div", {
        className: classes.withNameWrapper
      }, children, /*#__PURE__*/React.createElement(Typography, _extends({}, DisplayNameProps, {
        className: classNames(classes.smallName, {
          [classes.gutterright]: gutter === "right" || gutter === "both",
          [classes.smallName]: size === "small",
          [classes.mediumName]: size === "medium",
          [classes.largeName]: size === "large"
        })
      }), name));
      return children;
    }
  }, /*#__PURE__*/React.createElement(MuiAvatar, _extends({}, otherProps, {
    ref: ref,
    className: classNames("prmbl-avatar", className, classes.root, state || src ? classes.withImage : classes.withoutImage, hasChildren ? classes.withChildren : classes.withoutChildren, classes[size ? size : ""], classes[checkGutter()], {
      [classes.withName]: displayName === "right"
    }),
    alt: renderedAlt,
    src: src ? src : state
  }), renderedChildren)));
});
Avatar.defaultProps = {
  gutter: "none",
  size: "small"
};
Avatar.displayName = "Avatar";
export default Avatar;